module.exports = __webpack_public_path__ + "img/this-bonik.903489f0.svg";